module.exports = __webpack_public_path__ + "img/filter-circle-dollar.13a5631d.svg";